import React from 'react';
import PropTypes from 'prop-types';
import { PsSpinner } from '../spinner/PsSpinner';
import './PsDropdown.css';

export const PsDropdown = (
    {
        icon,
        counter,
        loading,
        onClick,
        children,
    },
) => {
    if (loading) {
        return (
            <PsSpinner className="ps-dropdown-spinner"/>
        );
    }

    return (
        <li className="dropdown ps-dropdown">
            <button
                className="button-icon"
                data-toggle="dropdown"
                onClick={onClick}
            >
                <i className="material-icons">{icon}</i>
                {
                    counter > 0 ? (
                        <span className="ps-dropdown-count">{counter}</span>
                    ) : null
                }
            </button>
            <ul className="dropdown-menu pull-right">
                {children}
            </ul>
        </li>
    );
};

PsDropdown.propTypes = {
    icon: PropTypes.string.isRequired,
    counter: PropTypes.number,
    onClick: PropTypes.func,
    loading: PropTypes.bool,
};

PsDropdown.defaultProps = {
    counter: 0,
    loading: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ps-dropdown/PsDropdown.jsx